'use client'

import Image from 'next/image'
import { RenderImage } from '@/devlink/DevLinkProvider'

export const ImageRenderer: RenderImage = ({
  src,
  alt,
  height,
  width,
  loading,
  className,
  ...props
}) => {
  const imgProps = {
    loading,
    className,
    src: typeof src === 'string' ? src : '',
    alt: alt || '',
    width: width === 'auto' ? undefined : (width as number),
    height: height === 'auto' ? undefined : (height as number),
    // Note: this will fill the image to its parent element container
    // so you'll need to style the parent container with the desired size.
    fill: width === 'auto' || height === 'auto',
    ...props,
  }

  return <Image {...imgProps} />
}
